<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-card> 
        <div slot="header">{{$dt('auditLogs.header','Activities')}}</div>
        <b-row>
          <b-col md="auto">
            <Pagination class="pull-right" :data="listPaginator" :limit="5" @pagination-change-page="onPageChange"/>
          </b-col>
        </b-row>
        <div v-if="contentIsLoading" class="text-center"> 
          <b-spinner type="grow" variant="primary"/>
        </div>
        <div v-else>
          <b-row>
            <b-col>
              <NoDataView v-if="!tableItems.length"/>
              <b-table v-else class="table-sm text-center" responsive bordered
                  :no-local-sorting=true
                  :sort-by.sync="filters.sort_field"
                  :sort-desc.sync="filters.sort_order"
                  :fields="tableFields"
                  :items="tableItems"
                  >
                <template #cell(causer_id)="{item}">
                  <span v-if="item.causer">{{item.causer.email}}</span>
                  <span v-else>{{$dt('auditLogs.causer_system','System process')}}</span>
                </template>               
                <!-- <template #cell(custom_column)="item"></template>                -->
              </b-table>
            </b-col>
          </b-row>
          <b-row>
            <b-col v-if="tableItems.length">
              <Pagination :data="listPaginator" :limit="5" @pagination-change-page="onPageChange" class="mb-0"/>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import Pagination from 'laravel-vue-pagination';
import NoDataView from '@/views/Shared/NoDataView.vue';
import Delete from '@/views/Shared/ModalDelete';
import Services from '@/services/index';

export default {
  mounted() {
    this.getData();
  },
  data() {
    return {
      list: {},
      contentIsLoading: true,
      
      filters: {
        sort_field: null,
        sort_order: true,
        search: '',
      },
      showDeleted: false,
    };
  },
  components: {
    Pagination, NoDataView
  },
  props: {
    page: {},
    embedded: { type: Boolean, default: false },
    subject_id: { type: Number, default: null },
    subject_type: { type: String, default: null },
  },
  computed: {
    tableFields() {
      return [
        { key: 'log_name', sortable: true, label: this.$t('global.title') },
        { key: 'description', sortable: true, label: this.$t('global.description') },
        { key: 'subject_id', sortable: true, label: this.$t('global.subject_id') },
        { key: 'causer_id', sortable: false, label: this.$t('global.causer_id') },
        { key: 'created_at', sortable: true, label: this.$dt('activityLogs.performed_at', 'Performed at') },
      ]; 
    },
    listPaginator() {
      return Object.is(this.list.meta, undefined) ? {} : this.list.meta;
    },
    tableItems() {
      if (!this.contentIsLoading) {
        return this.list.data;
      }
      return {};
    },
    params() {
      return {
        ...this.filters,
        subject_id: this.subject_id,
        subject_type: this.subject_type,
        page: this.page,
        sort_order: this.filters.sort_order ? 'desc' : 'asc',
      };
    },
  },
  watch: {
    page: 'getData',
    filters: { deep: true, handler: 'getData' },
  },
  methods: {
    deleteFn: Services.resources.delete,
    getData() {
      Services.auditLogs.list(this.params).then(({ data }) => {
        this.list = data;
        this.contentIsLoading = false;
      });
    },
    onPageChange(page) {
      page = page || this.page;
      if (!this.embedded && page !== this.page) this.$router.push({ name: 'AuditLogs', params: { page } });
    },
  }
};
</script>

<style scoped>
</style>
